import { NgModule } from "@angular/core";
import { AlphanumericDirective } from "./alphanumeric.directive";

@NgModule({
    declarations: [AlphanumericDirective],
    exports: [AlphanumericDirective]
})
export class AlphanumericModule {}